import produce from "immer";
import {
    SET_DEFINITION,
    SET_DEFINITIONS,
    DELETE_DEFINITION,
    REQUEST_SCENARIO_ANALYSIS_DATA,
    RECEIVE_SCENARIO_ANALYSIS_DATA,
    REQUEST_SCENARIO_ANALY_SBS_DATA,
    RECEIVE_SCENARIO_ANALY_SBS_DATA
} from "./actions";
import { SummaryType } from '@ls/grouping-service';
import SelectionState from "state/selections/SelectionState";
import {
    removeDefinitionFromState
} from "state/grid/utils";
//import { deleteDefinition } from 'state/grid/util';
//import { COMMIT_SELECTIONS } from 'state/selections/actions';
import { COMMIT_SELECTIONS } from "state/selections/actionTypes";


const defaultState = {
    definitions: {
        [SelectionState.UNCOMMITTED]: [],
        [SelectionState.COMMITTED]: []
    },
    fetchingData: {
        [SummaryType.ABSOLUTE]: false,
        [SummaryType.RELATIVE]: false,
    },
    data: {
        [SummaryType.ABSOLUTE]: null,
        [SummaryType.RELATIVE]: null
    },
    fetchingScenarioAnalysisSbsData: {
        [SummaryType.ABSOLUTE]: false,
        [SummaryType.RELATIVE]: false,
    },
    scenarioAnalysisSbsData: {
        [SummaryType.ABSOLUTE]: null,
        [SummaryType.RELATIVE]: null,
    },
};

export default produce((state = defaultState, action) => {
    switch (action.type) {
        case SET_DEFINITION: {
            const { definition, idx } = action;
            const selectedDefinitions = state.definitions[SelectionState.UNCOMMITTED];
            if (definition === null) {
                selectedDefinitions.splice(idx, 1);
            } else {
                selectedDefinitions[idx] = definition;
            }
            break;
        }
        case DELETE_DEFINITION:
            state.definitions = removeDefinitionFromState(state, action.payload);
            break;
        case SET_DEFINITIONS: {
            state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
            break;
        }
        case COMMIT_SELECTIONS: {
            state.analyticsData = defaultState.analyticsData;
            state.definitions[SelectionState.COMMITTED] = state.definitions[SelectionState.UNCOMMITTED];
            break;
        }
        case REQUEST_SCENARIO_ANALYSIS_DATA: {

            state.fetchingData[action.summary] = true;
            state.data[action.summary] = defaultState.data[action.summary];
            break;
        }
        case RECEIVE_SCENARIO_ANALYSIS_DATA: {
            state.fetchingData[action.summary] = false;
            state.data[action.summary] = action.data;

            break;
        }
        case REQUEST_SCENARIO_ANALY_SBS_DATA: {
            state.fetchingScenarioAnalysisSbsData[action.summary] = true;
            state.scenarioAnalysisSbsData[action.summary] =
                defaultState.scenarioAnalysisSbsData[action.summary];
            break;
        }
        case RECEIVE_SCENARIO_ANALY_SBS_DATA: {
            state.fetchingScenarioAnalysisSbsData[action.summary] = false;
            state.scenarioAnalysisSbsData[action.summary] = action.data;

            break;
        }
        default:
            return state
    }

})

